// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"28ba21a3cbac6152","572":"3dea10dfa1101969","927":"e9d470320cf4e142"}[chunkId] + ".css";
};